import { getAnalyticDataById } from "@src/analytics/getAnalyticData";
import popupHelper, { ESearchPopupType } from "./popupHelper";
import { searchEvent } from "@src/analytics";
/* 
  
window.dataLayer.push({
  "event": "search",
  "search_category": "area",
  "selected_province": "東京都",
  "selected_district": "東京都２３区",
  "selected_city": "江東区"
});

window.dataLayer.push({
  "event": "search",
  "search_category": "railway line and station",
  "selected_province": "愛知県",
  "selected_railway_line": "愛知環状鉄道線",
  "selected_station": "永覚"
});
*/

export function anaClickSearch() {
  const selectMap = popupHelper.getSelected();
  const prefectures = document.querySelector<HTMLLIElement>(
    ".container-search-popup li[data-resource-type=prefectures]"
  )?.dataset.resourceId;

  let lines = document.querySelector<HTMLLIElement>(
    ".container-search-popup li[data-resource-type=lines]"
  )?.dataset.resourceId;
  if (lines?.includes("-")) {
    lines = lines
      .split("-")
      .filter((item) => item)
      .at(-1);
  }

  const iterableIds = selectMap.values();
  let current = iterableIds.next();

  while (current.value) {
    //ans
    const id = current.value.code;
    const keyName = current.value.resourceType;
    getAnalyticDataById({ prefectures, lines, [keyName as string]: id }).then(
      (result) => {
        searchEvent({
          search_category:
            popupHelper.type === ESearchPopupType.area
              ? "area"
              : "railway line and station",
          selected_province: result.prefectures?.name ?? undefined,
          selected_city: result.districts,
          selected_district: result.cities?.name ?? "",
          selected_railway_line: result.lines?.name ?? undefined,
          selected_station: result.stations?.name ?? undefined,
        });
      }
    );
    current = iterableIds.next();
  }
}
